import { HttpClient } from 'base-app'

import * as API from '../configs'


class ManageInsuranceCar {
    static getContractsPending(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_CAR_PENDING}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getContractsAll(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_CAR_ALL}?${values}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getContractsPartner(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_CAR_PARTNERS}?${values}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getContractsPers(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_CAR_PERS}?${values}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getPartners(values) {
        return HttpClient.get(`${API.API_GET_PARTNER}/${values}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getContractsMotorAll(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTO_ALL}?${values}`, { params: { date: new Date().getMilliseconds() } })
    }

    static getContractsMotorPers(values) {
        return HttpClient.get(`${API.API_GET_CONSTRACTS_MOTO_PERS}?${values}`, { params: { date: new Date().getMilliseconds() } })
    }
}

export default ManageInsuranceCar
